import { c } from '../../../utils/tailwind-merge';
import { RichText } from '../../molecules/RichText/RichText';
import { ReleaseDetailProps } from './ReleaseDetail.types';

/**
 * Converts consecutive `<p>- text</p>` entries from CMS into a proper
 * `<ul><li>` list for accessibility. Non-list paragraphs are left unchanged.
 */
const convertListParagraphsToList = (html: string): string => {
  if (!/<p>\s*-\s*/.test(html)) return html;

  return html.replace(/((?:\s*<p>\s*-\s*.*?<\/p>\s*)+)/g, (block) => {
    const items = block
      .match(/<p>\s*-\s*(.*?)<\/p>/g)
      ?.map((item) => {
        const content = item.replace(/<p>\s*-\s*/, '').replace(/<\/p>/, '');
        return `<li>${content}</li>`;
      })
      .join('');
    return `<ul>${items}</ul>`;
  });
};

export const ReleaseDetail = ({
  released,
  detail,
  className = '',
}: ReleaseDetailProps) => {
  const semanticDetail = convertListParagraphsToList(detail);

  return (
    <article className={className}>
      <h4 className={c('mb-4 mt-6 text-xs text-grey-600 md:mb-5 md:mt-0')}>
        {released}
      </h4>
      <RichText
        type="div"
        html={semanticDetail}
        className="!m-0 !ml-0 whitespace-pre-line !p-0 !pl-0 text-sm text-grey-700 [&_li]:mb-1 [&_li]:ml-4 [&_p:last-child]:mb-0 [&_p]:mb-2 [&_ul]:mb-2 [&_ul]:list-['−_'] [&_ul]:pl-2"
      />
    </article>
  );
};
